/**
 * created by xcc on 2021/12/4
 * 新媒体更新、流程记录组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import noImg from './images/noImg.png';
import {
    Button,
    Modal,
    Table,
    Timeline
} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import Scrollbars from "react-custom-scrollbars";
import {formatMediaDate, formatTime, uuid} from "../../../../utils";
import Activiti from "./NewMediaManageActivity";
import {getNewMediaFields} from "../../actions/platformMaintenance";

export default class UpdateAndFlowRecord extends Component {
    static defaultProps = {}
    static propTypes = {
        auditRecordData: PropTypes.array,
        actHistoryData: PropTypes.array,
    }

    constructor(props) {
        super(props);
        this.state = {
            record: false,//审核记录
            flowVisible: false, //流程记录
            updateVisible: false, //修改记录
            updateRecordData: [], //修改记录数据
            flowRecordData: [], //流程记录数据
            currentData: {}
        };
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const columns = [
            {
                title: '审核类型',
                key: 'auditType',
                ellipsis: true,
                render: (text, record) => {
                    let processTypeName = "";
                    if (record.history[0].processData) {
                        processTypeName = record.history[0].processData.data.processTypeName ? record.history[0].processData.data.processTypeName : "新增";
                    }
                    return (
                        <div>{processTypeName + "审核"} </div>
                    )
                }
            },
            {
                title: '申请人',
                key: 'assigneeName',
                ellipsis: true,
                render: (text, record) => {
                    let createByName = "";
                    if (record.history[0].processData) {
                        createByName = record.history[0].processData.data.createByName;
                    }
                    return (
                        <div title={createByName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{createByName} </div>
                    )
                }
            },
            {
                title: '申请时间',
                key: 'startTime',
                ellipsis: true,
                render: (text, record) => {
                    return (
                        <div title={record.history[0].createTime ? formatTime(record.history[0].createTime) : null}
                             style={{
                                 overflow: "hidden",
                                 textOverflow: "ellipsis",
                                 whiteSpace: "nowrap"
                             }}>{record.history[0].createTime ? formatTime(record.history[0].createTime) : null} </div>
                    )
                }
            },
            {
                title: '结束时间',
                key: 'endTime',
                ellipsis: true,
                render: (text, record) => {
                    return (
                        <div
                            title={record.history[record.history.length - 1].updateTime ? formatTime(record.history[record.history.length - 1].updateTime) : null}
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{record.history[record.history.length - 1].updateTime ? formatTime(record.history[record.history.length - 1].updateTime) : null} </div>
                    )
                }
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                ellipsis: true,
                render: (text, record) => {
                    let statusName;
                    if (record.history[record.history.length - 1].processData) {
                        statusName = record.history[record.history.length - 1].processData.data.statusName;
                    }
                    return (
                        <div title={statusName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{statusName} </div>
                    )
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 200,
                render: (text, record, index) => {
                    return (
                        <div>
                            <a style={{display: 'inline-block'}} onClick={() => {
                                this.setState({flowVisible: true, currentData: record.history})
                            }}>流程记录</a>
                            <a style={{display: 'inline-block', marginLeft: '20px'}} onClick={() => {
                                this.updateRecord(record)
                            }}>修改记录</a>
                        </div>

                    )
                }
            }
        ];
        return (
            <div>
                <Modal
                    title="审核记录"
                    visible={this.state.record}
                    onCancel={() => {
                        this.setState({record: false})
                    }}
                    width={1000}
                    bordered
                    maskClosable={false}
                    zIndex={1000}
                    footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({record: false})
                        }}>关闭</Button>
                    </div>}
                >
                    <div id={"auditRecordTable"}>
                        <Scrollbars autoHide autoHeight autoHeightMax={500}>
                            <Table rowKey={record => record.key} dataSource={this.props.auditRecordData} columns={columns} pagination={false}/>
                        </Scrollbars>
                    </div>
                </Modal>
                <style>{
                    `#auditRecordTable .ant-table-body{border: 1px solid #e8e8e8;}
                `}</style>
                <Modal
                    title={"流程记录"}
                    zIndex={3000}
                    maskClosable={false}
                    visible={this.state.flowVisible}
                    onCancel={() => {
                        this.setState({flowVisible: false})
                    }}
                    footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({flowVisible: false})
                        }}>关闭</Button>
                    </div>}
                >
                    <div>
                        <Scrollbars
                            autoHide
                            autoHeight
                            autoHeightMax={600}
                        >
                            <div style={{
                                position: "relative",
                                paddingLeft: this.state.currentData && this.state.currentData.length ? 130 : ""
                            }}>
                                <Timeline
                                    style={{marginTop: '2px'}}>{this.state.currentData && this.state.currentData.length ? this.state.currentData.map(item => {
                                    let candidateNames = "";
                                    let operatorName = "";
                                    let endTime = "";
                                    let remark = item.otherData && item.otherData.remarks;
                                    operatorName = "操作人：" + item.operatorName;
                                    candidateNames = item.candidateNames.length ? ("候选人：" + (item.candidateNames.join("，"))) : "";
                                    endTime = Activiti.util.timeFormat(item.updateTime);
                                    return <Timeline.Item color="green" key={uuid()}>
                                        <div>开始时间：{Activiti.util.timeFormat(item.createTime)}</div>
                                        <div>结束时间：{endTime}</div>
                                        <div>{operatorName}</div>
                                        <div>{candidateNames}</div>
                                        {remark ? <div>备注：{remark}</div> : null}
                                        <div style={{position: "absolute", top: 0, left: -145}}>
                                            <span style={{
                                                display: "inline-block",
                                                textAlign: "right",
                                                width: "120px",
                                                fontWeight: "bold"
                                            }}>{item.taskName}</span>
                                        </div>
                                    </Timeline.Item>
                                }) : <Timeline.Item>无流程记录</Timeline.Item>}</Timeline>
                            </div>
                        </Scrollbars>
                    </div>
                </Modal>
                <Modal
                    title="修改记录"
                    zIndex={3000}
                    maskClosable={false}
                    visible={this.state.updateVisible}
                    onCancel={() => {
                        this.setState({updateVisible: false})
                    }}
                    width={600}
                    bordered
                    footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({updateVisible: false})
                        }} type={"primary"}>关闭</Button>
                    </div>}
                >
                    <div>
                        <Scrollbars
                            autoHide
                            autoHeight
                            autoHeightMax={500}>
                            {
                                this.state.updateRecordData && this.state.updateRecordData.map((item, index) => {
                                    return (
                                        <div key={index}
                                             style={{fontFamily: "MicrosoftYaHei Regular", fontSize: "14px"}}>
                                            <span style={{
                                                fontWeight: "bold",
                                                marginRight: "10px"
                                            }}>{index + 1}.</span>
                                            <span style={{fontWeight: "bold"}}>“{item.name}”</span>
                                            <span style={{margin: "0px 10px", color: "#aaa"}}>将</span>
                                            <span style={{fontWeight: "bold"}}>”{item.chProp}“</span>
                                            <span style={{margin: "0px 10px", color: "#aaa"}}>修改为</span>
                                            <span style={{
                                                fontWeight: "bold"
                                            }}>“{(item.chProp === "备案表" || item.chProp === "媒体logo") ? <img style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                                verticalAlign: "bottom"
                                            }} src={item.newText ? item.newText : noImg}/> : item.newText}”</span>
                                            <span style={{margin: "0px 10px", color: "#aaa"}}>原值为</span>
                                            <span style={{
                                                fontWeight: "bold"
                                            }}>”{(item.chProp === "备案表" || item.chProp === "媒体logo") && item.oldText ?
                                                <img style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    objectFit: "cover",
                                                    verticalAlign: "bottom"
                                                }} src={item.oldText ? item.oldText : noImg}/> : item.oldText}“</span>
                                        </div>
                                    )
                                })
                            }
                        </Scrollbars>
                    </div>
                </Modal>
            </div>
        )
    }

    getValue(item, callback) {
        item.fieldFillRules.length && item.fieldFillRules.forEach(i => {
            let value = i.keyValueMaps[item.value];
            if (value) {
                callback(value)
            }
        })
    }

    getMultipleValue(item, callback) {
        let value = [];
        item.fieldFillRules.length && item.fieldFillRules.forEach((i, index1) => {
            let keys = Object.keys(i.keyValueMaps);
            // console.log(i,"22222222222222222222222")
            keys.length && keys.forEach((j, index2) => {
                // console.log(i.keyValueMaps[j],"333333333333333333333333333333")
                if (item.value.indexOf(j) > -1) {
                    value.push(i.keyValueMaps[j])
                    // console.log(value,"444444444444444444444444444");
                }
                if (value.length) {
                    if (index1 === item.fieldFillRules.length - 1 && index2 === keys.length - 1) {
                        callback(value.join(","))
                    }
                }
            })
        })
    }

    //修改记录
    updateRecord(record) {
        //重组对比数据
        let needShowList = [];
        let list =JSON.parse(JSON.stringify(record.operation));
        //过滤掉修改流程中，审核不通过的数据
        // let list = _list.filter(item => {
        //     return item.taskName !== '更新审核不通过';
        // });
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (i > 0) {
                    let currentOld = list[i - 1];
                    let currentNew = list[i];
                    if ((currentOld.processData && currentOld.processData.data) &&
                        (currentNew.processData && currentNew.processData.data)
                    ) {
                        let oldData = JSON.parse(JSON.stringify(currentOld.processData.data));
                        let newData = JSON.parse(JSON.stringify(currentNew.processData.data));
                        //维护字段
                        oldData.ext.length && oldData.ext.forEach((item1) => {
                            newData.ext.length && newData.ext.forEach((item2) => {
                                if (item1.dbFieldName === item2.dbFieldName && !(item1.value.toString() === item2.value.toString())) {
                                    if ((item1.fieldType === 1 || item1.fieldType === 2)) {
                                        item1.value = item1.value + "";
                                        item2.value = item2.value + "";
                                    } else if (item1.fieldType === 3) {
                                        if (item1.value) {
                                            this.getValue(item1, (text) => {
                                                item1.value = item1.value ? text : "";
                                            })
                                        }
                                        if (item2.value) {
                                            this.getValue(item2, (text) => {
                                                item2.value = item2.value ? text : "";
                                            })
                                        }
                                    } else if (item1.fieldType === 4) {
                                        // console.log(item1.value,"000000000000000000")
                                        // console.log(item2.value,"111111111111111111")
                                        if (item1.value && item1.value.length) {
                                            this.getMultipleValue(item1, (text) => {
                                                // console.log(text, "55555555555555555")
                                                item1.value = item1.value ? text : "";
                                            })
                                        }
                                        // console.log("1111111111111222222222222222")
                                        if (item2.value && item2.value.length) {
                                            this.getMultipleValue(item2, (text) => {
                                                // console.log(text, "0000000__________")
                                                item2.value = item2.value ? text : "";
                                            })
                                        }
                                    } else if (item1.fieldType === 5) {
                                        item1.value = item1.value ? formatMediaDate(item1.value) : "";
                                        item2.value = item2.value ? formatMediaDate(item2.value) : "";
                                    }
                                    if (item1.value !== item2.value) {
                                        let currentItem = {
                                            name: currentNew.operatorName,
                                            chProp: item1.fieldName,
                                            newText: item2.value,
                                            oldText: item1.value,
                                        }
                                        needShowList.push(currentItem);
                                        console.log(needShowList)
                                    }
                                }
                            })
                        })
                        if (oldData.mainDeptId !== newData.mainDeptId) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '主责单位',
                                newText: newData.mainDeptName,
                                oldText: oldData.mainDeptName,
                            }
                            needShowList.push(currentItem)
                        }
                        if (oldData.name !== newData.name) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '媒体名称',
                                newText: newData.name,
                                oldText: oldData.name,
                            }
                            needShowList.push(currentItem)
                        }
                        let newRecordTable = newData.recordTable && Object.keys(JSON.parse(newData.recordTable)).length ? JSON.parse(newData.recordTable).path : "";
                        let oldRecordTable = oldData.recordTable && Object.keys(JSON.parse(newData.recordTable)).length ? JSON.parse(oldData.recordTable).path : "";
                        if (newRecordTable !== oldRecordTable) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '备案表',
                                newText: newRecordTable,
                                oldText: oldRecordTable,
                            }
                            needShowList.push(currentItem)
                        }
                        if (oldData.newMediaTypeId !== newData.newMediaTypeId) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '媒体平台',
                                newText: newData.newMediaTypeName,
                                oldText: oldData.newMediaTypeName,
                            }
                            needShowList.push(currentItem)
                        }
                        if (oldData.logo !== newData.logo) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '媒体logo',
                                newText: newData.logo,
                                oldText: oldData.logo,
                            }
                            needShowList.push(currentItem)
                        }
                    }
                }
            }
            if (needShowList.length > 0) {
                this.setState({
                    updateRecordData: needShowList,
                    updateVisible: true
                })
            } else {
                message.error("暂无修改记录");
            }
        }
    }
}